import { render, staticRenderFns } from "./mb-frequency-select.vue?vue&type=template&id=58619c49&scoped=true&"
import script from "./mb-frequency-select.vue?vue&type=script&lang=ts&"
export * from "./mb-frequency-select.vue?vue&type=script&lang=ts&"
import style0 from "./mb-frequency-select.vue?vue&type=style&index=0&id=58619c49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58619c49",
  null
  
)

export default component.exports